module.exports = __webpack_public_path__ + "static/media/eb389106-2d9d-4e60-b035-415dfdb3b123.1b6544aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/eb389106-2d9d-4e60-b035-415dfdb3b123.png
// module id = 1465
// module chunks = 0